import React from "react"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import { Link } from "react-router"
import FontAwesome from "react-fontawesome"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { formatCurrency, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../../lib/blockingFetch"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import { Col, Row } from "react-bootstrap"

export default class RenderBucket extends React.Component {

  state = {
    showUpdateBucket: false,
    showUnlinkBucket: false,
    running: false,
    success: false,
    error: null,
    bucketId: '',
    bucketIdValidationState: VALIDATION_TYPE.NULL
  }

  handleUpdate = () => this.setState({ 
    showUpdateBucket: true,
    bucketId: this.props.bucket ? this.props.bucket.id : '',
    bucketIdValidationState: VALIDATION_TYPE.NULL,
    running: false,
    success: false,
    error: null
  })

  handleUnlink = () => this.setState({ 
    showUnlinkBucket: true,
    running: false,
    success: false,
    error: null
  })

  bucketIdChanged = bucketId => this.setState({
    bucketId,
    bucketIdValidationState: validateTextState(bucketId, false),
    error: null,
  })

  confirmUpdate = () => {

    const { bucketId } = this.state,
    bucketIdState = validateTextState(bucketId, false)

    if (bucketIdState !== VALIDATION_TYPE.SUCCESS) {
      this.setState({
        error: 'Invalid bucket.',
        bucketIdValidationState: bucketIdState
      })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { batchId, reloadFinancierBatch } = this.props

    blockingFetchService(
      accessToken => apiServerApi.addBatchFinancierBucket(accessToken, bucketId, batchId),
      _ => {
        this.setState({ success: true })
        setTimeout(this.closeUpdate, 1000)
        reloadFinancierBatch(batchId)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  confirmUnlink = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { bucket: { id: bucketId }, batchId, reloadFinancierBatch } = this.props

    blockingFetchService(
      accessToken => apiServerApi.removeBatchFinancierBucket(accessToken, bucketId, batchId),
      resp => {
        this.setState({ success: true })
        setTimeout(this.closeUnlink, 1000)
        reloadFinancierBatch(batchId)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeUpdate = () => this.setState({ showUpdateBucket: false })

  closeUnlink = () => this.setState({ showUnlinkBucket: false })

  updateContent = () => {

    const { running, success, error, bucketId, bucketIdValidationState } = this.state,
    { buckets } = this.props

    return (
      <div>
        <Row>
          <Col xs={12}>

            <FormControlInlineSelect
              controlId='bucketId' validationState={ bucketIdValidationState }
              label='Bucket' value={ bucketId }
              onChange={ this.bucketIdChanged }
              options={ buckets }
              withEmptyOption={ true }
              helpText={ bucketIdValidationState === VALIDATION_TYPE.ERROR ? 'Choose a bucket' : '' }
            />
          </Col>
        </Row>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  unlinkContent = () => {
    const { running, success, error } = this.state
    return (
      <div>
        <h3>Do you really want to unlink this bucket?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = className => (
    <span className={ `cursor-pointer ${ className } p-5` }
      onClick={ this.handleUpdate } title='Update'>
      <FontAwesome name="pencil" />
    </span>
  )

  renderUnlink = () => (
    <span className="red cursor-pointer ml-10 p-5" title="Unlink this bucket!"
      onClick={ this.handleUnlink }>
      <FontAwesome name='trash' />
    </span>
  )

  renderContent = () => {

    const { bucket, closed } = this.props
    if (!bucket) return !closed && this.renderUpdateLink('')

    const { id, name, amount } = bucket
    return <div>
      <Link to={`/financiers/buckets/${id}/detail`} title='Show details'>
        { name } ({ formatCurrency(amount) })
      </Link>
      { !closed && this.renderUpdateLink('ml-10') }
      { !closed && this.renderUnlink() }
    </div>
  }

  render() {  
    const { showUpdateBucket, running, showUnlinkBucket } = this.state

    return <div>

      <SimpleCardRow name='Bucket' value={ this.renderContent() } />

      <AlertModal
        show={ showUpdateBucket }
        title='Update bucket'
        body={ this.updateContent() }
        bsStyle="info"
        close={ this.closeUpdate }
        confirm={ this.confirmUpdate }
        proceedText="Proceed"
        disabled={ running }
      />

      <AlertModal
        show={ showUnlinkBucket }
        title='Unlink bucket'
        body={ this.unlinkContent() }
        bsStyle="danger"
        close={ this.closeUnlink }
        confirm={ this.confirmUnlink }
        proceedText="Proceed"
        disabled={ running }
      />      
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/RenderBucket.js